import { render, staticRenderFns } from "./PowerSummarizerHead.vue?vue&type=template&id=0f9b177d&scoped=true"
import script from "./PowerSummarizerHead.vue?vue&type=script&lang=js"
export * from "./PowerSummarizerHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9b177d",
  null
  
)

export default component.exports